(function(){'use strict';
var FS_INDUSTRIAL_PRODUCT_IDS=[8063840157872,8063840190640,8063840223408,8063840288944,8063840321712,8063849988272,8063850021040,8063850053808,8063850086576,8063850119344,8063850250416,8063850348720,8063850479792,8063850578096,8063850676400,8063851364528,8063851462832,8063851561136,8063851659440,8063851757744,8063852150960,8063852216496,8063852282032];
var FS_ELIGIBLE_PRODUCT_IDS=(window.FS_TIER_ELIGIBLE_PRODUCT_IDS&&window.FS_TIER_ELIGIBLE_PRODUCT_IDS.length?window.FS_TIER_ELIGIBLE_PRODUCT_IDS:[7452453798064,8062744723632,7453187047600,7479732043952,7452466151600,7454343135408,7453197271216,7453227155632,7482282016944,7480484135088,7454351360176,7454367613104,7454429249712]);
function fsHasIndustrial(cart){return !!(cart&&cart.items&&cart.items.some(function(item){return FS_INDUSTRIAL_PRODUCT_IDS.indexOf(Number(item.product_id))!==-1}))}
function fsLineTotal(item){return Number(item.final_line_price||item.line_price||0)||((Number(item.final_price||item.price||0)*Number(item.quantity||0))||0)}
function fsEligibleTotal(cart){return cart&&cart.items?cart.items.reduce(function(sum,item){var id=Number(item.product_id);if(FS_ELIGIBLE_PRODUCT_IDS.indexOf(id)===-1)return sum;return sum+fsLineTotal(item)},0):0}function fsHasIndustrialLine(cart){return!!(cart&&cart.items&&cart.items.some(function(item){return FS_INDUSTRIAL_PRODUCT_IDS.indexOf(Number(item.product_id))!==-1}))}function fsHideForSpecialityOnly(cart){return fsHasIndustrialLine(cart)&&fsEligibleTotal(cart)<=0}/* FS_SPECIALITY_ONLY_HIDE_20260618 */ /* FS_PAGE_ONLY_HIDE_ESSENTIAL_COUNT_20260619 */
function fsSetTierVisible(visible){var wraps=document.querySelectorAll('.fs9b-wrap,.fs9-wrap,.tiers-progress,.fs-tiers-v2');[].forEach.call(wraps,function(wrap){if(wrap.getAttribute('data-tier-hidden')==='true'){wrap.style.display='none';return}wrap.style.display=visible?'':'none'})}
// Inject minimal CSS only for track layout
var st=document.createElement('style');
st.textContent='.fs9-track{display:flex;gap:3px;height:16px;margin:12px 0 8px}.fs9-seg{flex:1;height:100%;border-radius:3px;transition:all .3s ease}';
document.head.appendChild(st);

function load(){
var c=document.getElementById('fs9-track');
if(!c){setTimeout(load,300);return}

// Create 9 segments
c.innerHTML='';
for(var i=0;i<9;i++){var s=document.createElement('div');s.className='fs9-seg';c.appendChild(s)}
var segs=c.children;
var msg=document.getElementById('fs9-msg'),nx=document.getElementById('fs9-next'),dc=document.getElementById('fs9-disc'),ml=document.querySelectorAll('.fs9-mile');

function u(t){
var fill=Math.floor(t/100000);fill=Math.min(fill,9);fill=Math.max(fill,0);
// Set segment colors directly via JS (bypasses CSS issues)
for(var i=0;i<9;i++){
var bg='#e0e0e0'; // empty = gray
if(i<fill){bg=(i<3?'#c62828':i<6?'#e65100':'#2e7d32')} // filled: red/orange/green
else if(i===fill){bg=(i<3?'#c62828':i<6?'#e65100':'#2e7d32')} // pulsing = same color
segs[i].style.background=bg;
segs[i].style.opacity=(i<fill?'1':i===fill?'.6':'1');
}

// Milestones
[].forEach.call(ml,function(e){
t>=parseInt(e.getAttribute('data-t'),10)?e.classList.add('ok'):e.classList.remove('ok')
});

// Messages
var n=(300000-t)/100;
t>=900000?msg.textContent='🎉 5% off + Free Shipping! All tiers unlocked!':
t>=600000?msg.textContent='🎉 2.5% off + Free Shipping! Keep going for 5%!':
t>=300000?msg.textContent='🎉 Free Shipping unlocked! Go for 2.5% off!':
t>0?msg.textContent='🔥 Add '+n.toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for Free Shipping!':
msg.textContent='🛒 Add 3,000 EGP to cart for Free Shipping!';

t>=900000?nx.textContent='🏆 Best deal active!':
t>=600000?nx.textContent='Add '+((900000-t)/100).toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for 5% off!':
t>=300000?nx.textContent='Add '+((600000-t)/100).toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for 2.5% off!':
t>0?nx.textContent='Add '+n.toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for Free Shipping':
nx.textContent='';

t>=900000?dc.textContent='✓ 5% + Free Shipping at checkout':
t>=600000?dc.textContent='✓ 2.5% + Free Shipping at checkout':
t>=300000?dc.textContent='✓ Free Shipping at checkout':
dc.textContent='';
}

var x=new XMLHttpRequest;
x.open('GET','/cart.js',!0);
x.onload=function(){try{var cart=JSON.parse(x.responseText);fsSetTierVisible(true);u(fsEligibleTotal(cart))}catch(e){}};
x.send();
document.addEventListener('cart:updated',function(){x.send()});
document.addEventListener('cart:added',function(){x.send()});
document.addEventListener('cart:removed',function(){x.send()});
document.addEventListener('cart:changed',function(){x.send()});
setInterval(function(){x.send()},2000);
}
load()})();

/* FS force next-tier bottom text for fs-tiers-v2 - 2026-06-12 */
(function(){'use strict';
var FS_INDUSTRIAL_PRODUCT_IDS=[8063840157872,8063840190640,8063840223408,8063840288944,8063840321712,8063849988272,8063850021040,8063850053808,8063850086576,8063850119344,8063850250416,8063850348720,8063850479792,8063850578096,8063850676400,8063851364528,8063851462832,8063851561136,8063851659440,8063851757744,8063852150960,8063852216496,8063852282032];
var FS_ELIGIBLE_PRODUCT_IDS=(window.FS_TIER_ELIGIBLE_PRODUCT_IDS&&window.FS_TIER_ELIGIBLE_PRODUCT_IDS.length?window.FS_TIER_ELIGIBLE_PRODUCT_IDS:[7452453798064,8062744723632,7453187047600,7479732043952,7452466151600,7454343135408,7453197271216,7453227155632,7482282016944,7480484135088,7454351360176,7454367613104,7454429249712]);
function fmt(c){return Math.max(0,c/100).toLocaleString('en-EG',{minimumFractionDigits:0})}
function txt(t){if(t>=900000)return 'Best deal active!';if(t>=600000)return fmt(900000-t)+' EGP left to unlock 6% off';if(t>=300000)return fmt(600000-t)+' EGP left to unlock 3% off';return fmt(300000-t)+' EGP left to unlock Free Shipping'}
function paint(t){var e=document.getElementById('fs9b-next')||document.querySelector('.fs9b-next');if(!e)return;e.textContent=txt(t||0);e.style.display='block';e.style.minHeight='1.2em';e.style.margin='7px 0';e.style.fontSize='14.875px';e.style.lineHeight='1.2';e.style.color='#c62828';e.style.fontWeight='700'}
function hasIndustrial(cart){return !!(cart&&cart.items&&cart.items.some(function(item){return FS_INDUSTRIAL_PRODUCT_IDS.indexOf(Number(item.product_id))!==-1}))}
function lineTotal(item){return Number(item.final_line_price||item.line_price||0)||((Number(item.final_price||item.price||0)*Number(item.quantity||0))||0)}
function eligibleTotal(cart){return cart&&cart.items?cart.items.reduce(function(sum,item){var id=Number(item.product_id);if(FS_ELIGIBLE_PRODUCT_IDS.indexOf(id)===-1)return sum;return sum+lineTotal(item)},0):0}
function setTierVisible(visible){var wraps=document.querySelectorAll('.fs9b-wrap,.fs9-wrap');[].forEach.call(wraps,function(wrap){if(wrap.getAttribute('data-tier-hidden')==='true'){wrap.style.display='none';return}wrap.style.display=visible?'':'none'})}
function run(){var x=new XMLHttpRequest;x.open('GET','/cart.js?fs_next='+Date.now(),true);x.onload=function(){try{var cart=JSON.parse(x.responseText);setTierVisible(true);paint(eligibleTotal(cart))}catch(e){paint(0)}};x.onerror=function(){paint(0)};x.send()}
document.addEventListener('DOMContentLoaded',run);document.addEventListener('cart:updated',run);document.addEventListener('cart:added',run);document.addEventListener('cart:removed',run);document.addEventListener('cart:changed',run);setTimeout(run,400);setInterval(run,3000);
})();

(function () {
  function installThinCartAssurance() {
    if (document.getElementById('fs-cart-assurance-thin-override')) return;

    var style = document.createElement('style');
    style.id = 'fs-cart-assurance-thin-override';
    style.textContent = [
      '.fs-cart-assurance-section .page-width{max-width:none!important;padding-right:16px!important;padding-left:16px!important}',
      '.fs-cart-assurance{grid-template-columns:repeat(5,minmax(0,1fr))!important;gap:8px!important;width:100%!important;max-width:none!important;padding:8px 10px!important;border-radius:6px!important}',
      '.fs-cart-assurance__item{grid-column:auto!important;min-height:30px!important;padding:5px 10px!important;font-size:12px!important;line-height:1.1!important;letter-spacing:.04em!important}',
      '@media screen and (max-width:749px){.fs-cart-assurance-section .page-width{padding-right:10px!important;padding-left:10px!important}.fs-cart-assurance{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:6px!important;width:100%!important;max-width:none!important;padding:7px!important}.fs-cart-assurance__item{min-height:28px!important;padding:5px 6px!important;font-size:9px!important;letter-spacing:.03em!important}.fs-cart-assurance__item:first-child{grid-column:1/-1!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installThinCartAssurance);
  } else {
    installThinCartAssurance();
  }
})();

/* FS floating WhatsApp firefighter avatar - 2026-06-12 */
(function () {
  'use strict';
  var imageUrl = 'https://cdn.shopify.com/s/files/1/0638/0217/9760/t/5/assets/fs-whatsapp-firefighter.png?v=1781224292';

  function installFirefighterButton() {
    if (!document.getElementById('fs-whatsapp-firefighter-style')) {
      var style = document.createElement('style');
      style.id = 'fs-whatsapp-firefighter-style';
      style.textContent = [
        '.fs-global-whatsapp-firefighter{position:fixed!important;right:1.25rem!important;bottom:2%!important;z-index:55!important;display:block!important;width:68px!important;height:68px!important;padding:0!important;border:2px solid rgba(255,255,255,.95)!important;border-radius:50%!important;overflow:hidden!important;background:#f9f1e8!important;box-shadow:0 8px 22px rgba(0,0,0,.22)!important;line-height:0!important}',
        '.fs-global-whatsapp-firefighter img{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:50% 24%!important}',
        '.section-whatsapp-button [class^="whatsapp-container-"]{display:none!important}',
        '.section-whatsapp-button .otsb_nope,.section-whatsapp-button .fs-whatsapp-firefighter-widget{display:block!important;height:auto!important;overflow:visible!important;visibility:visible!important;width:auto!important;opacity:1!important}',
        '.section-whatsapp-button [class^="whatsapp-container-"]{position:fixed!important;right:1.25rem!important;bottom:2%!important;z-index:50!important;display:none!important;align-items:flex-end!important}',
        '.section-whatsapp-button [class^="whatsapp-label-container-"]{position:relative!important;display:flex!important;align-items:center!important}',
        '.section-whatsapp-button button[id^="send-whatsapp-chat-"]{width:68px!important;height:68px!important;padding:0!important;border:2px solid rgba(255,255,255,.95)!important;border-radius:50%!important;overflow:hidden!important;background:#f9f1e8 url("' + imageUrl + '") center 24% / cover no-repeat!important;box-shadow:0 8px 22px rgba(0,0,0,.22)!important}',
        '.section-whatsapp-button button[id^="send-whatsapp-chat-"]>svg{display:none!important}',
        '.section-whatsapp-button .fs-whatsapp-firefighter{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:50% 24%!important}'
      ].join('');
      document.head.appendChild(style);
    }

    if (!document.getElementById('fs-global-whatsapp-firefighter')) {
      var link = document.createElement('a');
      link.id = 'fs-global-whatsapp-firefighter';
      link.className = 'fs-global-whatsapp-firefighter';
      link.href = 'https://wa.me/201005060555';
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'Chat with Fire Safe on WhatsApp');

      var globalImg = document.createElement('img');
      globalImg.src = imageUrl;
      globalImg.alt = '';
      globalImg.width = 68;
      globalImg.height = 68;
      globalImg.loading = 'lazy';
      link.appendChild(globalImg);
      document.body.appendChild(link);
    }

    document.querySelectorAll('.section-whatsapp-button button[id^="send-whatsapp-chat-"]').forEach(function (button) {
      if (!button.querySelector('.fs-whatsapp-firefighter')) {
        var img = document.createElement('img');
        img.className = 'fs-whatsapp-firefighter';
        img.src = imageUrl;
        img.alt = 'Chat with Fire Safe on WhatsApp';
        img.width = 68;
        img.height = 68;
        button.appendChild(img);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installFirefighterButton);
  } else {
    installFirefighterButton();
  }
  setTimeout(installFirefighterButton, 800);
})();

